//https://github.com/sergeyleschev/react-custom-hooks
import { useCallback, useEffect, useState } from "react"

export default function useAsync<T>(callback: () => Promise<T>, dependencies: any[] = []) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error>();
    const [value, setValue] = useState<T>();
    const [promise, setPromise] = useState<Promise<T>>(callback);

    const callbackMemoized = useCallback(() => {
        setLoading(true);
        setError(undefined);
        setValue(undefined);

        callback()
            .then(setValue)
            .catch(setError)
            .finally(() => setLoading(false));

    }, dependencies);

    useEffect(() => {
        callbackMemoized()
    }, [callbackMemoized]);

    return { loading, error, value, setValue }
}